import { ApiService } from '@core/services/api/api.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { getExtensionsApiUrl } from '@pages/checkout-app/utils/api.utils';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ExtensionsApiService {
  EXTENSIONS_API_URL = getExtensionsApiUrl();
  constructor(
    private http: HttpClient,
    private apiService: ApiService,
  ) {}

  public getHeaders(options?): HttpHeaders {
    let headers = new HttpHeaders();
    // let the content-type be set automatically for multipart/form-data, because of boundary
    if (!options || !options.contentType) {
      headers = headers.set('Content-Type', 'application/json');
    }
    headers = headers.set('Authorization', `Bearer ${this.apiService.jwtToken}`);
    return headers;
  }

  public post(path: string, options = {}): Observable<any> {
    return this.http.post(this.EXTENSIONS_API_URL + path, { ...options }, { headers: this.getHeaders() }).pipe(
      catchError((error) => {
        console.error('Extensions API POST Error:', error.message);
        return throwError(error);
      }),
    );
  }

  public get(path: string, options = {}): Observable<any> {
    return this.http
      .get(this.EXTENSIONS_API_URL + path, {
        ...options,
        headers: this.getHeaders(),
      })
      .pipe(
        catchError((error) => {
          console.error('Extensions API GET Error:', error.message);
          return throwError(error);
        }),
      );
  }

  public delete(path: string, options = {}): Observable<any> {
    return this.http
      .delete(this.EXTENSIONS_API_URL + path, {
        ...options,
        headers: this.getHeaders(),
      })
      .pipe(
        catchError((error) => {
          console.error('Extensions API DELETE Error:', error.message);
          return throwError(error);
        }),
      );
  }

  public patch(path: string, options = {}): Observable<any> {
    return this.http.patch(this.EXTENSIONS_API_URL + path, { ...options }, { headers: this.getHeaders() }).pipe(
      catchError((error) => {
        console.error('Extensions API PATCH Error:', error.message);
        return throwError(error);
      }),
    );
  }

  public patchMultipart(path: string, formData: FormData): Observable<any> {
    return this.http
      .patch(this.EXTENSIONS_API_URL + path, formData, {
        headers: this.getHeaders({ contentType: 'multipart' }),
      })
      .pipe(
        catchError((error) => {
          console.error('Extensions API PATCH multipart Error:', error.message);
          return throwError(error);
        }),
      );
  }

  public put(path: string, options = {}): Observable<any> {
    return this.http.put(this.EXTENSIONS_API_URL + path, { ...options }, { headers: this.getHeaders() }).pipe(
      catchError((error) => {
        console.error('Extensions API PUT Error:', error.message);
        return throwError(error);
      }),
    );
  }
}
